import {createSlice} from "@reduxjs/toolkit";
import axiosInstance from "../../API/Axios/AxiosConfig";
import URLS from "../../API/Axios/URLS";
import {getStipePublicKey} from "../../API/ApiEndPoints/payments";

const initalState = {
    publicKey: ""
}


const StripePublicKeySlice = createSlice({
    name: "guide",
    initialState: initalState,
    reducers: {
        fetchPublicKey: async (state, action) => {
            try {
                state.publicKey = await getStipePublicKey();
                console.log("public_key",state.publicKey)
            } catch (e) {
                state.publicKey = await getStipePublicKey();
            }
            return state
        },
    }
})


export const {fetchPublicKey} = StripePublicKeySlice.actions
export default StripePublicKeySlice.reducer